import "./modules/common";
import VueApp from "~/Scripts/new/vueApp";
import ProductGlance from "~/Components/Products/ProductGlance.vue";
import TabInfo from "~/Components/Products/Tabs/TabInfo.vue";
import ProductFaqs from "~/Components/Products/ProductFaqs.vue";
import HeroCarousel from "~/Components/Base/HeroCarousel.vue";
import DefaultModal from "~/Components/Base/DefaultModal.vue";
import EmbeddedVideo from "~/Components/Common/EmbeddedVideo.vue";
import SupportPromiseCard from "~/Components/Products/SupportPromiseCard.vue";

new VueApp( {
  name: "ProductItem",
  components: {
    SupportPromiseCard,
    ProductGlance,
    TabInfo,
    ProductFaqs,
    HeroCarousel,
    DefaultModal,
    EmbeddedVideo,
  },
  data () {
    return {
      layout: {
        maxWidth: 1500,
      },
      videoDimensions: {
        maxWidth: "1500px",
      },
    };
  },
  unmounted () {
    this.removeEventListeners();
  },
  mounted () {
    this.setEventListeners();
    this.setGTagEvents();
  },
  computed: {
    videoWrapperEl () {
      return this.$refs["embedded-video-wrapper"];
    },
  },
  methods: {
    setGTagEvents () {
      const name = document.querySelector( "meta[name=\"product-name\"]" ).content;

      if ( name ) {
        this.$gtag.onEvent( { ecommerce: null } );
        this.$gtag.onEvent( {
          ecommerce: {
            currencyCode: "GBP",
            impressions: [
              {
                name,
              },
            ],
          },
        } );
      }
    },
    setEventListeners () {
      window.addEventListener( "resize", this.determineVideoWrapperMaxWidth );
    },
    removeEventListeners () {
      window.removeEventListener( "resize", this.determineVideoWrapperMaxWidth );
    },
    doesVideoFitScreenDimensions () {
      let result = false;

      if ( this.videoWrapperEl ) {
        const { clientHeight: videoWrapperHeight } = this.videoWrapperEl;
        const { innerHeight: visibleScreenHeight } = window;

        if ( visibleScreenHeight && videoWrapperHeight ) {
          result = visibleScreenHeight >= videoWrapperHeight;
        }
      }
      return result;
    },
    determineVideoWrapperMaxWidth () {
      if ( this.doesVideoFitScreenDimensions() ) {
        this.videoDimensions.maxWidth = `${this.layout.maxWidth}px`;
      } else {
        const calculatedMaxWidth = ( window.innerHeight * 16 ) / 9;
        this.videoDimensions.maxWidth = `${calculatedMaxWidth}px`;
      }
    },
  },
} );
